import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";
import { SplashState } from "./splash-state/SplashState";
import { BoardState } from "./board-state/BoardState";

export class TutorialLayer extends Phaser.Group {

    public onSplash: boolean;

    private audioOnButton: Phaser.Button;
    private audioOffButton: Phaser.Button;
    private exitButton: Phaser.Button;
    private scaledItemsContainer: Phaser.Group;
  
    constructor(game: Phaser.Game) {

        super(game, null, "tutorial-layer");

        this.scaledItemsContainer = new Phaser.Group(this.game);
        this.scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        this.scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.scaledItemsContainer.scale.y = GameVars.scaleY;
        this.add(this.scaledItemsContainer);

        const tmpBackground = <Phaser.Sprite>this.scaledItemsContainer.create(0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        tmpBackground.scale.set(GameConstants.GAME_WIDTH , GameConstants.GAME_HEIGHT);
        tmpBackground.anchor.set(.5);
        tmpBackground.alpha = .65;
        this.scaledItemsContainer.add(tmpBackground);

        this.audioOnButton = new Phaser.Button(this.game,  GameConstants.GAME_WIDTH - 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickAudioButton, this);
        this.audioOnButton.setFrames( "btn_sound_on", "btn_sound_on", "btn_sound_on", "btn_sound_on");
        this.audioOnButton.anchor.set(.5);
        this.audioOnButton.scale.y = GameVars.scaleY;
        this.add(this.audioOnButton);

        this.audioOffButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH - 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickAudioButton, this);
        this.audioOffButton.setFrames( "btn_sound_off", "btn_sound_off", "btn_sound_off", "btn_sound_off");
        this.audioOffButton.anchor.set(.5);
        this.audioOffButton.scale.y = GameVars.scaleY;
        this.add(this.audioOffButton);

        this.exitButton = new Phaser.Button(this.game, 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickBack, this);
        this.exitButton.setFrames( "btn_resume", "btn_resume", "btn_resume", "btn_resume");
        this.exitButton.anchor.set(.5);
        this.exitButton.scale.y = GameVars.scaleY;
        this.add(this.exitButton);

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        const border = new Phaser.Graphics(this.game);
        border.beginFill(0x4d2600, 1);
        border.drawRoundedRect(-350, -400, 700, 885, 32);
        this.scaledItemsContainer.add(border);

        const rectangle = new Phaser.Graphics(this.game);
        rectangle.beginFill(0xffffcc, 1);
        rectangle.drawRoundedRect(-340, -390, 680, 865, 32);
        this.scaledItemsContainer.add(rectangle);

        const text1 = new Phaser.Text(this.game, 0, -275, "1. Some cells contain mines, if you click on a cell containing a mine, you lose, but if you manage to reveal the rest of the cells (without blowing up any mines) you win.", {font: "26px Eczar", fill: "#331a00"});
        text1.anchor.set(.5);
        text1.wordWrap = true;
        text1.wordWrapWidth = 600;
        this.scaledItemsContainer.add(text1);

        const tuto1 = new Phaser.Image(this.game, 205, -195, "texture_atlas_1", "tutorial_1");
        tuto1.anchor.set(.5);
        this.scaledItemsContainer.add(tuto1);

        const text2 = new Phaser.Text(this.game, 0, -25, "2. Clicking a cell which doesn't have a mine reveals the number of surrounding squares containing mines. Use this information and some guesswork to avoid them.", {font: "26px Eczar", fill: "#331a00"});
        text2.anchor.set(.5);
        text2.wordWrap = true;
        text2.wordWrapWidth = 600;
        this.scaledItemsContainer.add(text2);

        const tuto2 = new Phaser.Image(this.game, 165, 80, "texture_atlas_1", "tutorial_2");
        tuto2.anchor.set(.5);
        this.scaledItemsContainer.add(tuto2);

        const text3 = new Phaser.Text(this.game, 0, 245, "3. To reveal a cell, point and click on it. If you think that in a square there is a bomb, mark it with a flag, by holding click button.", {font: "26px Eczar", fill: "#331a00"});
        text3.anchor.set(.5);
        text3.wordWrap = true;
        text3.wordWrapWidth = 600;
        this.scaledItemsContainer.add(text3);

        const tuto3 = new Phaser.Image(this.game, 215, 345, "texture_atlas_1", "tutorial_3");
        tuto3.anchor.set(.5);
        this.scaledItemsContainer.add(tuto3);

        const tuto4 = new Phaser.Image(this.game, -225, 415, "texture_atlas_1", "tutorial_char");
        tuto4.anchor.set(.5);
        this.scaledItemsContainer.add(tuto4);

        const division1 = new Phaser.Image(this.game, 0, 155, "texture_atlas_1", "tutoria_divisor");
        division1.anchor.set(.5);
        this.scaledItemsContainer.add(division1);

        const division2 = new Phaser.Image(this.game, 0, -135, "texture_atlas_1", "tutoria_divisor");
        division2.anchor.set(.5);
        this.scaledItemsContainer.add(division2);
    }

    private onClickAudioButton(): void {
        
        AudioManager.toggleAudioState();

        if (GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    }

    private onClickBack(): void {
        if (GameVars.tutorialFromSplash) {
            SplashState.currentInstance.closeTutorial();
        } else {
            try {
                BoardState.currentInstance.pauseLayer.closeTutorial();
            } catch (error) {
                BoardState.currentInstance.matchOverLayer.closeTutorial();
            }
        }

        AudioManager.playSound("btn_click");
    }
}
